import React from "react";
import style from "../../Style.module.scss";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import CircularProgress from "../../../../components/CircularProgress/CircularProgress";
import TrendPercent from "../../../../components/TrendPercent/TrendPercent";
import AlertDot from "../../../../components/AlertDot/AlertDot";
import useCommonStore from "../../../../stores/common";

function ChildRow({ children = [1] }) {
  const showDetails = useCommonStore((state) => state.showDetails);

  return (
    <>
      <tr className={`${style.child_app} ${style.line} ${style.border_bottom}`}>
        {/* <td></td> */}
        {/* <td></td> */}
        <td>Cardinal Health</td>
        <td>
          <StatusDot color="#37B450" />
        </td>
        {!showDetails && <td>$ -</td>}
        <td>
          <CircularProgress value={12} />
        </td>
        <td>$ 2,000</td>
        {!showDetails && (
          <td>
            <TrendPercent percent={-56} />
          </td>
        )}
        {!showDetails && <td>12/31/2022</td>}
        <td>
          <AlertDot />
        </td>
      </tr>

      {children.map((app, index) => (
        <tr
          className={`${style.child_app} ${children.length == index + 1 ? "" : style.line} ${children.length == index + 1 ? "" : style.child_app_br_bottom} ${style.border_bottom}`}
        >
          {/* <td></td> */}
          {/* <td></td> */}
          <td>Cardinal Health</td>
          <td>
            <StatusDot color="#37B450" />
          </td>
          {!showDetails && <td>$ -</td>}
          <td>
            <CircularProgress value={12} />
          </td>
          <td>$ 2,000</td>
          {!showDetails && (
            <td>
              <TrendPercent percent={-56} />
            </td>
          )}
          {!showDetails && <td>12/31/2022</td>}
          <td>
            <AlertDot />
          </td>
        </tr>
      ))}
    </>
  );
}

export default ChildRow;
